import { Fragment, FunctionComponent, ReactElement, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import SideNavigation from '@/components/ui/side-navigation';
import useAuth from '@/shared/context/auth-context';
import Backdrop from '@/components/ui/backdrop';
import rolesConfig from '@/core/config/roles';
import './admin-panel.scss';

const AdminPanel: FunctionComponent = (): ReactElement => {
	const { user } = useAuth();
	const navigationItems = useMemo(() => user && rolesConfig[user.role].navigationItems, [user]);

	if (!user || !navigationItems) {
		return <Backdrop />;
	}

	return (
		<Fragment>
			<SideNavigation {...navigationItems} />
			<Outlet />
		</Fragment>
	);
};

export default AdminPanel;
